import { render } from "./SectionBase.vue?vue&type=template&id=79105f96"
import script from "./SectionBase.vue?vue&type=script&lang=js"
export * from "./SectionBase.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/scripts/view/portfolio/sections/SectionBase.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "79105f96"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('79105f96', __exports__)) {
    api.reload('79105f96', __exports__)
  }
  
  module.hot.accept("./SectionBase.vue?vue&type=template&id=79105f96", () => {
    api.rerender('79105f96', render)
  })

}


export default __exports__